module.exports = __webpack_public_path__ + "static/icons/icon-snowing--color-443ca7ac071f5c2d2b57864316c912fe.svg";